import BasePage from '../../components/base-page/base-page';
import BlogSearch from '../../components/search/search';
import Share from '../../../shared/utils/share/share';
import SideScrollingBanner from '../../components/side-scrolling-banner/side-scrolling-banner';
import defineBlogAppBannerElement from '../../components/blog-app-banner/blog-app-banner';
import GoUpButton from '../../components/go-up-button/go-up-button';
import Carousel from '../../components/carousel/carousel';

import breakpoints from '../../config/breakpoints';
import config from '../../../shared/config/config';

import analytics, { events } from '../../../shared/analytics';

import './post.scss';

class PostPage extends BasePage {
  ui = {
    articleTitle: '.js-article-title',
    searchInput: '.js-search-input',
    goUpButton: '.js-go-up-button',
    sliderBanner: '.js-slider-banner',
    subscribeBanner: '.js-subscribe-banner',
  };

  uiCollections = {
    contentBannerButton: '.js-promo-banner-cta',
    appBannerButton: 'blog-app-banner',
    useCaseBannerLink: '.use-case-banner a', // choose all links inside use-case-banner that's created on blog
    sliderBannerButton: '.js-slider-banner-cta',
    sliderBannerApp: '.slider-banner-slide',
    deprecatedPromoBanner: '.promo-banner',
  };

  events = {
    'click @uiCollections.contentBannerButton': 'handleContentBannerButtonClick',
    'click @uiCollections.appBannerButton': 'handleAppBannerButtonClick',
    'click @uiCollections.useCaseBannerLink': 'handleUseCaseBannerLinkClick',
    'click @uiCollections.sliderBannerButton': 'handleSliderBannerButtonClick',
    'click @uiCollections.sliderBannerApp': 'handleSliderBannerAppClick',
    'click @uiCollections.deprecatedPromoBanner': 'handlePromoBannerClick',
  };

  onInit() {
    super.onInit();

    if (this.ui.searchInput) {
      new BlogSearch().init();
    }

    new Share().init();
    new SideScrollingBanner().init();

    if (this.ui.goUpButton) {
      new GoUpButton(this.ui.articleTitle).init();
    }

    defineBlogAppBannerElement();

    if (this.ui.sliderBanner) {
      this.sliderBanner = new Carousel({
        rootElement: this.ui.sliderBanner,
        slidesPerPage: {
          [breakpoints.sm]: 3,
        },
      });
      this.sliderBanner.init();
    }

    this.updatePromoBannerStyle();
    this.makeLegacyPromoNewBannersClickable();
  }

  makeLegacyPromoNewBannersClickable = () => {
    const signupUrl = config.get('customerAccountPages.signup');
    if (!signupUrl) return;

    const banners = document.querySelectorAll('.promo-new-banner');
    banners.forEach((banner) => {
      if (banner.querySelector('.promo-new-banner__link-wrapper')) return;

      const wrapper = banner.querySelector('.promo-new-banner__wrapper');
      if (!wrapper) return;

      const link = document.createElement('a');
      link.href = signupUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.className = 'promo-new-banner__link-wrapper js-promo-banner-cta';

      while (wrapper.firstChild) {
        link.appendChild(wrapper.firstChild);
      }
      wrapper.appendChild(link);

      if (this.newSetappCustomerAccountReleased) {
        this.signupButtonToLink(link);
      } else {
        link.addEventListener('click', this.handleContentBannerButtonClick);
      }
    });
  };

  updatePromoBannerStyle = () => {
    const deprecatedPromoBanners = this.uiCollections.deprecatedPromoBanner;

    if (deprecatedPromoBanners.length > 0) {
      deprecatedPromoBanners.forEach((banner) => {
        banner.style.cursor = 'pointer';
      });
    }
  };

  handlePromoBannerClick = (event) => {
    this.signupModal.open();

    this.sendAnalyticsEventOnPromoBannerClick(event);
  };

  handleSliderBannerButtonClick = (e) => {
    let showSignUpModal = true;
    const href = e.target.getAttribute('href');

    const eventValue = e.target.closest('aside').className;

    try {
      const url = new URL(href);
      if (!url.pathname.startsWith('/signup')) {
        showSignUpModal = false;
      }
    } catch (error) {
      showSignUpModal = false;
    }

    if (showSignUpModal) {
      e.preventDefault();
      this.signupModal.open();
    }

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel: 'Try free',
      eventLabel2: 'Slider apps banner',
      eventValue,
    });
  };

  handleSliderBannerAppClick = (e) => {
    const eventValue = e.target.closest('aside').className;
    const eventLabel = e.currentTarget.id;

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'Slider apps banner',
      eventValue,
    });
  };

  handleContentBannerButtonClick = (event) => {
    let showSignUpModal = true;
    const link = event.target.closest('a');
    const href = link?.getAttribute('href');

    try {
      const url = new URL(href);
      if (!url.pathname.startsWith('/signup')) {
        showSignUpModal = false;
      }
    } catch (error) {
      showSignUpModal = false;
    }

    if (showSignUpModal) {
      event.preventDefault();
      this.signupModal.open();
    }

    this.sendAnalyticsEventOnPromoBannerClick(event);
  };

  handleAppBannerButtonClick = (e) => {
    const eventLabel = e.currentTarget.getAttribute('name');

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'app-banner',
    });
  };

  handleUseCaseBannerLinkClick = (e) => {
    const { textContent: eventLabel } = e.currentTarget;

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'use-case-banner',
    });
  };

  sendAnalyticsEventOnPromoBannerClick = (event) => {
    const banner = event.target.closest('.promo-banner, .promo-new-banner');
    const bannerHeader = banner?.querySelector('.promo-banner__description-header, .promo-new-banner__description-header');
    const eventLabel = bannerHeader?.textContent ?? '';

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'promo-banner',
    });
  };
}

export default PostPage;

PostPage.initOnDomLoaded();
